export enum ELanguages {
  es = 'es',
  en = 'en',
  cat = 'cat',
  eus = 'eus',
  pt = 'pt'
}
